import { render, staticRenderFns } from "./appPrivacyResults.vue?vue&type=template&id=1ee53e88&scoped=true"
import script from "./appPrivacyResults.vue?vue&type=script&lang=js"
export * from "./appPrivacyResults.vue?vue&type=script&lang=js"
import style0 from "./appPrivacyResults.vue?vue&type=style&index=0&id=1ee53e88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee53e88",
  null
  
)

export default component.exports